import '@bcz/pen/es/global'
import '@bcz/nib/es/global'
import './styles/index.less'
// import '@/mock'

import { render } from 'react-dom'
import App from './App'
import axios from 'axios'
axios.interceptors.response.use(res => res.data) // 拦截器

// import 'intersection-observer' // 引入intersectionObserver polyfill 解决老版本浏览器兼容性问题

render(<App />, document.querySelector('#root'))
